// Refactored SurveyRenderer.jsx
import React, { useMemo, useCallback } from 'react';
import ParagraphContainer from 'projects/components/ParagraphContainer';
import { useTranscriptData } from 'hooks/useTranscriptData';
import useSelectionData from 'hooks/useSelectionData';

const SurveyRenderer = ({
  transcriptId,
  transcriptText,
  selectedExcerptId,
  select,
  page,
  onParagraphClick,
  onTitleClick,
  questionText,
  logo,
  color,
  hasEditPermission
}) => {
  // Use shared transcript data processing - create transcript object shape
  const transcriptData = useMemo(() => ({ body: transcriptText }), [transcriptText]);
  
  const { speakerColorHash, visibleParagraphs } = useTranscriptData(
    transcriptData?.body, 
    page
  );

  // Use the shared selection hook to create selection data
  const selection = useSelectionData(
    selectedExcerptId,
    select,
    transcriptId,
    'SurveyAnswer'
  );

  // Create paragraph click handler with transcript ID
  const handleParagraphClick = useCallback((start, end) => {
    if (onParagraphClick) {
      onParagraphClick(start, end, transcriptId);
    }
  }, [onParagraphClick, transcriptId]);

  // Render paragraphs directly using visibleParagraphs
  const paragraphItems = visibleParagraphs.map((paragraph, index) => {
    if (!paragraph || (paragraph.start === paragraph.end)) {
      return null;
    }

    return (
      <ParagraphContainer
        key={`${transcriptId}_${paragraph.paragraphIndex}`}
        paragraph={paragraph}
        speakerColorHash={speakerColorHash}
        selection={selection}
        absoluteIndex={paragraph.index}
        paragraphIndex={index}
        transcriptID={transcriptId}
        codeableType="SurveyAnswer"
        canEdit={false}
        isPrint={false}
        hasEditPermission={hasEditPermission}
        onParagraphClick={handleParagraphClick}
        hideTitle={index !== 0}
        title={index === 0 ? questionText : null}
        onTitleClick={onTitleClick}
        logo={logo}
        color={color}
        disableEditing={true} // Disable editing for surveys
      />
    );
  }).filter(Boolean);

  return <div>{paragraphItems}</div>;
};

export default SurveyRenderer;